<template>
  <transition name="peekBox">
    <div
      id="peekBox"
      @mouseover="$emit('overPeekBox')"
      @mouseleave="$emit('leavePeekBox')"
      :style="{ top: peekBoxTop + 'px', left: peekBoxLeft + 'px' }"
      v-show="showPeekBox"
      v-html="boxContent"
    ></div>
  </transition>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      peekBoxTop: 0,
      peekBoxLeft: 0
    };
  },
  props: {
    boxContent: String,
    eventClientX: Number,
    eventClientY: Number,
    showPeekBox: Boolean,
    isInPeekBox: Boolean,
    height: {
      type: Number,
      default: 16
    },
    width: {
      type: Number,
      default: 24
    }
  },
  watch: {
    eventClientX(newVal, _) {
      const viewPortWidth = this.getViewportWidth();
      this.peekBoxLeft =
        newVal + 16 * this.width > viewPortWidth
          ? newVal - (newVal + 16 * this.width - viewPortWidth) - 16
          : newVal + 16;
    },
    eventClientY(newVal, prevVal) {
      const viewPortHeight = this.getViewportHeight();
      this.peekBoxTop =
        newVal + 16 * this.height > viewPortHeight
          ? newVal - (newVal + 16 * this.height - viewPortHeight) - 16
          : newVal - 16;
    }
  },
  methods: {
    getViewportWidth() {
      let viewPortWidth;

      if (typeof window.innerWidth !== "undefined") {
        // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
        viewPortWidth = window.innerWidth;
      } else if (
        typeof document.documentElement !== "undefined" &&
        typeof document.documentElement.clientWidth !== "undefined" &&
        document.documentElement.clientWidth !== 0
      ) {
        // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
        viewPortWidth = document.documentElement.clientWidth;
      } else {
        // older versions of IE
        viewPortWidth = document.getElementsByTagName("body")[0].clientWidth;
      }
      return viewPortWidth;
    },
    getViewportHeight() {
      let viewPortHeight;

      if (typeof window.innerWidth !== "undefined") {
        // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
        viewPortHeight = window.innerHeight;
      } else if (
        typeof document.documentElement !== "undefined" &&
        typeof document.documentElement.clientWidth !== "undefined" &&
        document.documentElement.clientWidth !== 0
      ) {
        // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
        viewPortHeight = document.documentElement.clientHeight;
      } else {
        // older versions of IE
        viewPortHeight = document.getElementsByTagName("body")[0].clientHeight;
      }
      return viewPortHeight;
    }
  },
  emits: ["overPeekBox", "leavePeekBox"]
})
export default class PeekBox extends Vue {
  boxContent!: string;
  showPeekBox!: boolean;
  eventClientX!: number;
  eventClientY!: number;
  height?: number;
  width?: number;
  isInPeekBox!: boolean;
}
</script>
